import { AlertIcon } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { OutboundSmsLogCard } from 'src/components/sms-modal/outbound-sms-log-card.component'
import { ESmsLogStatuses } from 'src/types/sms-log'
import type { TSmsLog } from 'src/types/sms-log'
import { getReadableDateWithHours } from 'src/utils/date-formatter.util'
import { useTimezonePreference } from 'src/providers/timezone-preference.provider'

const DashboardSmsLog = ({ smsLog }: { smsLog: TSmsLog }) => {
  const { t } = useTranslation()
  const { displayTimezone } = useTimezonePreference()

  const date = smsLog.deliveredAt ? getReadableDateWithHours(t, smsLog.deliveredAt, displayTimezone) : ''

  return (
    <div>
      {smsLog.status === ESmsLogStatuses.DELIVERED || smsLog.status === ESmsLogStatuses.READ ? (
        <p className="c-text-red-800 c-flex c-gap-2 c-mb-0 c-pb-0">
          {t('pages.dashboard.dashboard-sms-log.sms-received', { date })}
        </p>
      ) : (
        <p className="c-text-red-800 c-flex c-gap-2 c-mb-0 c-pb-0">
          <AlertIcon color="RED" className="c-h-5" />
          {t('pages.dashboard.dashboard-sms-log.sms-not-received')}
        </p>
      )}
      <OutboundSmsLogCard smsLog={smsLog} />
    </div>
  )
}
export default DashboardSmsLog
